module.exports = __webpack_public_path__ + "static/media/helena.f96cead4.png";